<template>
  <div class="main">
    <Toast />
    <FormulairesLogic
      :userData="userData"
      :showValidation="showValidation"
      :isWorking="isWorking"
      :desac="false"
      @update="$emit('update', $event)"
      @saveDossier="$emit('saveDossier', $event)"
      v-slot="logic"
      >
      <template v-if="logic.load === 2">
        <aside class="sidebar">
          <div>

    
            <div class="progress-part">
              <h1 id="titreEleve">Création du dossier</h1>
    
              <div class="progress-bar">
                <div
                  class="progress-bar-inner"
                  :style="{ width: progressPercent(logic.step) + '%' }"
                ></div>
              </div>
    
    
              <div class="progress-info">
                <span>Étape {{ logic.step }} / 4</span>
                <span>{{ progressPercent(logic.step) }}%</span>
              </div>


              <ul class="step-list">
                <li :class="{ active: logic.step >= 1 }">Infos personnelles</li>
                <li :class="{ active: logic.step >= 2 }">
                  Infos administratives
                </li>
                <li :class="{ active: logic.step >= 3 }">
                  Questionnaire conduite
                </li>
                <li :class="{ active: logic.step >= 4 }">
                  Contrat
                </li>
              </ul>
            </div>
          </div>
          <a  class="navbar-brand" href="#">
              <img 
                id="iconLogo"
                @click="logic.goToHome()"
                :src="require('../../assets/images/logoMonPermis.png')"/>
          </a>
    
    
    
        </aside>
        <div class="layout">
          <section class="content">
            <header id="head">
              <img 
                id="iconHome"
                @click="logic.goToHome()"
                :src="require('../../assets/images/iconHome.png')"/>
            </header>

            <div id="title">
                <p class="title" v-if="logic.step === 1">Informations personnelles</p>
                <p class="subtitle" v-if="logic.step === 1">Saisissez vos coordonnées et <br> commencez la création de votre dossier.</p>

                <p class="title" v-else-if="logic.step === 2">Informations administratives</p>
                <p class="subtitle" v-if="logic.step === 2">Renseignez les champs nécessaires et <br> nous pourrons instruire le dossier.</p>

                <p class="title" v-else-if="logic.step === 3">Questionnaire conduite</p>
                <p class="subtitle" v-if="logic.step === 3">Répondez au questionnaire et<br> nous estimerons vos besoins d'apprentissage.</p>

                <p class="title" v-else-if="logic.step === 4">Votre Contrat</p>
                <p class="subtitle" v-if="logic.step === 4">Validez votre contrat et <br> nous pourrons finaliser votre dossier.</p>


            </div>

            <FormulairesStep1
              v-if="logic.step === 1"
              v-bind="logic"
            />
            <FormulairesStep2
              :desac=false
              v-else-if="logic.step === 2"
              v-bind="logic" 
            />
            <FormulairesStep3
              v-else-if="logic.step === 3"
              v-bind="logic"
            />
            <FormulairesStep5
              v-else-if="logic.step === 4"
              v-bind="logic"
              @updateCodeSignature="logic.updateCodeSignature"
              @updateCodeSignatureParent="logic.updateCodeSignatureParent"
            />
          </section>



        </div>
      </template>
      <template v-else>
        <Loader />
      </template>
    </FormulairesLogic>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import Toast from "primevue/toast";
import FormulairesLogic from "./FormulairesLogic.vue";
import FormulairesStep1 from "./FormulairesStep1.vue";
import FormulairesStep2 from "./FormulairesStep2.vue";
import FormulairesStep3 from "./FormulairesStep3.vue";
import FormulairesStep5 from "./FormulairesStep5.vue";

export default {
  name: "FormulairesWizard",
  components: {
    Loader,
    Toast,
    FormulairesLogic,
    FormulairesStep1,
    FormulairesStep2,
    FormulairesStep3,
    FormulairesStep5,
  },
  props: {
    userData: { type: Object, required: true },
    showValidation: { type: Boolean, default: false },
    isWorking: { type: Boolean, default: false },
  },
  methods: {
    progressPercent(step) {
      return Math.round(((step - 1) * 100) / 3);
    },
  },
};
</script>

<style scoped>


.main {
display: grid;
  grid-template-columns: repeat(1, 310px) repeat(1, 1fr);
  grid-gap: 10px;
  padding: 10px 0 10px 10px;
  min-height: 420px;
  height: 100vh;
  background: linear-gradient(323deg, #fbbb5b 35%, #de6fa8 100%, #07989f 0%);
min-width: 320px;
overflow-x: hidden;
background: url(/img/fond2.cf1e6c4d.png) bottom left no-repeat padding-box, linear-gradient(299deg, #fbbb5b 0%, #de6fa8 100%) 0% 0% no-repeat padding-box !important;
}

@media screen and (min-width:769px) {
  .main {
    min-height: 570px;
    height: 100vh;
  }

  .layout {
    min-height: 550px;

}
}
.layout {
  display: flex;
  width: 100%;
}

.sidebar {
  width: 246px;
  padding: 10px;
  color: #000000;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.navbar-brand{
  margin-right: 0;
  padding: 20px;
  background: #fffa;
  border-radius: 20px;
}
.navbar-brand img{
  border-radius: 20px;
  border: solid #fff 4px;
  width: 100%;
}

.content {
  padding: 20px;
  background: #ffffff;
  overflow-y: auto;
  position: relative;
  border-radius: 20px;
  display: grid;
  width: 100%;
  justify-content: center;
  grid-template-rows: auto 1fr auto;
  /* max-height: calc(100vh - 66px); */
}




@media screen and (min-width: 769px) {
  .layout{
    display: flex;
    width: calc(100% - 256px - 20px);
    border-radius: 20px;
    align-items: stretch;
    height: calc(100vh - 20px);
  }
  .content {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;

    margin: 10px 0;
    border-bottom-left-radius: 20px;
  }

}

.title {
  font-size: 32px;
  margin-top: 2rem;
  font-weight: 600;
}

p.subtitle{
  margin-bottom: 2rem;
  margin-bottom: 0;
}

.progress-part {
  margin-top: 2rem;
  width: 100%;
  background-color: #fff8;
  padding: 20px 20px 10px;
  margin: 0 auto;
  border-radius: 20px;
  backdrop-filter: blur(5px);
}

.progress-info {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.progress-bar {
  height: 8px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 999px;
}

.progress-bar-inner {
  height: 100%;
  background: #07989f;
  width: 0;
  transition: width 0.3s ease;
}

.step-list {
  list-style: none;
  margin: 1.5rem 0 0;
  padding: 0;
  font-size: 0.9rem;
  text-align: left;
}

.step-list li {
  position: relative;
  padding-left: 1.5rem;
  margin-bottom: 0.75rem;
  opacity: 0.5;
}

.step-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.35rem;
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
  border: 2px solid #ffffff;
  background: transparent;
}

.step-list li.active {
  opacity: 1;
  font-weight: 600;
}

.step-list li.active::before {
  background: #07989f;
  border-color: #07989f;
}

#head {
  margin: 0 0 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  min-width: 330px;
  position: absolute;
  right: 20px;
  top: 20px;
}


#titreEleve {
  font-size: 1.2em;
  font-weight: bold;
  color: #000000;
  text-align: left;
}


#iconHome {
  cursor: pointer;
  width: auto;
  height: 28px;
}

@media screen and (max-width:768px) {
    
  :deep() .field > input:focus ~ label,
  input:not(:placeholder-shown) ~ label,
  :deep() .field > select:focus ~ label,
  select:not(:placeholder-shown) ~ label {
    max-width: 300px;

    text-wrap: nowrap;
    text-overflow: ellipsis;
  }
}
:deep() .form-dossier{
  margin: 0 auto;
  max-width: 600px;
  overflow-x: hidden;
  overflow-y: scroll;
  width: 100%;
}

:deep() .footer-form{
}

:deep() div.btnForm{
  background-color: #fff;
  padding: 8px 0 0 0;
  display: flex;
  justify-content: space-between;
  max-width: 600px;
  justify-self: stretch;
}

:deep() .p-button.btnForm{
  background-color: #07989f;
  border-color: #07989f;
  font-weight: 600;
  border-radius: 2em;
  font-size: 1.035em;
  line-height: 1em;
  padding: 10px 1em 8px;
  margin: 0;

}
:deep() .p-button.btnForm:hover{
  background-color: #04959d;
  border-color: #07989f;

} 
:deep() p.errorMsg{
  max-width: 600px;
  color: red;
  margin-top: 1em;
  font-size: .8em;
  max-width: 600px;
  background: red;
  border-radius: 10px;
  font-weight: bolder;
  text-align: left;
  margin-bottom: 0;
  margin: 20px 0 0 0;
  padding: 10px;
  background: linear-gradient(-323deg,#fbbb5baa 90%, #de6fa8aa 100%);
}



@media only screen and (max-width: 768px) {

  .sidebar{
    width: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .sidebar #head{
    margin-top: 0;
  }

  .step-list{
    margin: 0;
    display: flex;
  }
  .progress-part {
    margin: 0;
    border-radius: 0;
    overflow: visible;
    flex-direction: column;
    height: 1rem;

  }
  .progress-part .progress-bar{
    background-color: #f9e1ee;
    width: 100%;
    border-radius: 0;
  }
  .progress-part .progress-bar-inner{
    background: linear-gradient(323deg, #fbbb5b 35%, #de6fa8 100%, #07989f 0%);
    border-radius: 0;
  }

  .main{
    display: flex;
    flex-direction: column;
    padding: 0;
    justify-content: start;
    min-width: 320px;
    min-height: 480px;
  }

  .layout{
    flex-direction: column;
    height: calc(100vh - 56px);
    z-index: 2;
  }

  .sidebar{
    height: 56px;
    margin: 0;
    margin-top: 0px;
    width: 100%;
    flex-direction: column-reverse;
    align-items: end;
    justify-content: flex-end;
    position: relative;
    margin-top: 0;
    overflow: visible;
    min-width: 330px;

  }

  .progress-info > span:last-of-type{
    display: none;
  }

  .sidebar > div:first-of-type{
    width: 100%;
    margin-top: 20px;
    z-index: 4;
  }
  a.navbar-brand{
    max-width: 97px;
    height: auto;
    box-shadow: none;
    background: none;
    background-color: rgba(0, 0, 0, 0);
    padding: 0;
    position: absolute;
    z-index: 1;
    right: 10px;
    top: 17px;
    min-height: 60px;
    background-color: #fff;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  a.navbar-brand img{
    border: solid #fff 2px;
  }

  .progress-part{
    padding: 0;
    background-color: transparent;
    backdrop-filter: none;
  }

  .progress-info {
    padding: 0 20px;
  }
  .step-list{
    display: none;
  }

  h1#titreEleve{
  margin-left: 10px;
    margin-bottom: 0;
    position: relative;
    bottom: 0px;
    max-width: 204px;
    background-color: #fff;
    padding: 10px 10px 7px 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .content{
    border-radius: 0;
    grid-template-rows: auto 1fr .25fr;
height: calc(100vh - 66px);
min-height: 424px;
  }

  #title {
    background-color: #fff;
    margin-bottom: 2rem;
  }

  .title {
    font-size: 17px;
  }
}



@media only screen and (max-width: 500px) {

}

  

  </style>


